import TrackWrapper from '~/components/common/TrackWrapper';
import {
  CardContent,
  CardTitle,
  CardWrapper,
  GridWrapper,
  SectionTitle,
  SectionWrapper
} from './EvBasics.styles';
import evBasicsContent from './EvBasicsData';

type CardProps = {
  imgProps: React.ImgHTMLAttributes<HTMLImageElement>;
  title: string;
  content: string;
};

const Card = ({ imgProps, title, content }: CardProps) => (
  <CardWrapper>
    <img {...imgProps} className="h-56 w-56" />
    <CardTitle>{title}</CardTitle>
    <CardContent>{content}</CardContent>
  </CardWrapper>
);

export default function EvBasics() {
  return (
    <TrackWrapper event={{ eventName: 'Viewed - Ev Basics' }}>
      <SectionWrapper>
        <SectionTitle>
          Check the basics: history, condition and mileage
        </SectionTitle>
        <GridWrapper>
          {evBasicsContent.map(({ title, ...rest }) => (
            <Card key={title} title={title} {...rest} />
          ))}
        </GridWrapper>
      </SectionWrapper>
    </TrackWrapper>
  );
}
